var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tooltip',{staticClass:"w-100",attrs:{"animated":true,"label":(_vm.storageUsedHumanReadable + " used on " + _vm.limit),"type":_vm.storageUsed < 60 ? 'is-success' : (_vm.storageUsed < 80 ? 'is-warning' : 'is-danger'),"position":"is-right"}},[_c('progress',{staticClass:"progress mt-2",class:{
          'is-success': _vm.storageUsed < 60,
          'is-warning': _vm.storageUsed >= 60 && _vm.storageUsed < 80,
          'is-danger': _vm.storageUsed >= 80,
        },attrs:{"max":"100"},domProps:{"value":_vm.storageUsed}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }